import * as Sentry from '@sentry/browser';
import type { actionProps } from '@/contexts/toast-notification/ToastNotificationContext';

export type errorApiType = {
  response: {
    data: {
      errors: {
        cpf: string;
        rg: string;
        email: string;
      };
    };
  };
};

type catchApiResponseType = {
  err: errorApiType;
  toastNotificationDispatch: React.Dispatch<actionProps>;
  setDocumentsApiError: React.Dispatch<React.SetStateAction<string>>;
  setBasicInformationApiError: React.Dispatch<React.SetStateAction<boolean>>;
  currentState: string;
  clientId: string;
};

const catchApiResponse = (props: catchApiResponseType): void => {
  const {
    err,
    toastNotificationDispatch,
    setDocumentsApiError,
    setBasicInformationApiError,
    currentState,
    clientId,
  } = props;

  toastNotificationDispatch({
    type: 'close',
    payload: { text: '', title: '' },
  });

  if (
    err.response?.data?.errors?.cpf?.includes('has already been taken') ||
    err.response?.data?.errors?.cpf?.includes(
      "can't be equal to candidate's cpf",
    )
  ) {
    setDocumentsApiError('cpf');
    toastNotificationDispatch({
      type: 'error',
      payload: {
        title: 'Erro ao cadastrar pessoa avalista',
        text: 'Esse número de CPF já foi inserido anteriormente. Por favor, insira outro número.',
      },
    });
  } else if (
    err.response?.data?.errors?.rg?.includes('has already been taken') ||
    err.response?.data?.errors?.rg?.includes("can't be equal to candidate's rg")
  ) {
    setDocumentsApiError('rg');
    toastNotificationDispatch({
      type: 'error',
      payload: {
        title: 'Erro ao cadastrar pessoa avalista',
        text: 'Esse número de RG já foi inserido anteriormente. Por favor, insira outro número.',
      },
    });
  } else if (
    err.response?.data?.errors?.email?.includes('has already been taken') ||
    err.response?.data?.errors?.email?.includes(
      "can't be equal to candidate's email",
    )
  ) {
    setBasicInformationApiError(true);
    toastNotificationDispatch({
      type: 'error',
      payload: {
        title: 'E-mail já utilizado',
        text: 'Insira um novo e-mail, precisamos de um por pessoa para a etapa de assinatura digital.',
      },
    });
  } else {
    toastNotificationDispatch({
      type: 'error',
      payload: {
        title: 'Erro ao cadastrar pessoa avalista',
        text: 'Tente novamente ou contate o administrador',
      },
    });
    const payload = {
      userId: clientId,
      currentState,
    };
    Sentry.setUser({ id: clientId });
    Sentry.captureException({ err, payload });
  }
};

export default catchApiResponse;
